import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinkTypesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-view',
	path: '/secure/admin/ViewLinkTypes!default.jspa',
};
